import { render, staticRenderFns } from "./DownloadBtn.vue?vue&type=template&id=3a94a46d"
import script from "./DownloadBtn.vue?vue&type=script&lang=js"
export * from "./DownloadBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a94a46d')) {
      api.createRecord('3a94a46d', component.options)
    } else {
      api.reload('3a94a46d', component.options)
    }
    module.hot.accept("./DownloadBtn.vue?vue&type=template&id=3a94a46d", function () {
      api.rerender('3a94a46d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Commons/DownloadBtn.vue"
export default component.exports